var _excluded = ["children", "extraStyles"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import AriaModal from 'react-aria-modal';
import { ClassNames } from '@emotion/core';
import AllhomesMobileDialogFrame from './allhomes-mobile-dialog-frame';
import * as styles from './allhomes-mobile-dialog.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesMobileDialog = props => {
  var children = props.children,
    extraStyles = props.extraStyles,
    otherProps = _objectWithoutProperties(props, _excluded);
  return ___EmotionJSX("div", {
    css: styles.container
  }, ___EmotionJSX(ClassNames, null, _ref => {
    var css = _ref.css;
    return ___EmotionJSX(AriaModal, {
      includeDefaultStyles: false,
      underlayClass: css(styles.ariaUnderlay(extraStyles.underlay)),
      dialogClass: css(styles.ariaDialog(extraStyles.dialog)),
      titleText: props.title
    }, ___EmotionJSX("div", {
      css: styles.modalPanel
    }, ___EmotionJSX(AllhomesMobileDialogFrame, _extends({
      extraStyles: extraStyles
    }, otherProps), children)));
  }));
};
AllhomesMobileDialog.propTypes = {
  title: PropTypes.string.isRequired,
  closeButton: PropTypes.bool,
  backButton: PropTypes.string,
  rightButton: PropTypes.string,
  onRightButton: PropTypes.func,
  onClose: PropTypes.func,
  children: PropTypes.node,
  rightButtonDisabled: PropTypes.bool,
  extraStyles: PropTypes.shape({
    dialog: PropTypes.shape({}),
    heading: PropTypes.shape({}),
    title: PropTypes.shape({}),
    closeButton: PropTypes.shape({}),
    underlay: PropTypes.shape({})
  })
};
AllhomesMobileDialog.defaultProps = {
  closeButton: false,
  backButton: null,
  rightButton: null,
  onClose: () => {},
  onRightButton: () => {},
  children: [],
  rightButtonDisabled: false,
  extraStyles: {}
};
export default AllhomesMobileDialog;
export { AllhomesMobileDialog as BaseAllhomesMobileDialog };